import React from 'react';
import { number } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import Notice from '../Notice';
import { percentFormatter } from '../formatters/percent';
import { wrapTextWithTagFormatter } from '../formatters/wrapTextWithTag';
import { deleteMessage } from '../api/delete';
import { DISCOUNT_AMOUNT } from './constants';

import styles from './style.module.scss';

const ReferralProgramInviteeDiscountNotice = ({
    messageId,
    userId
}) => {
    const message = (
        <I18n k="layout.referral_program_invitee_discount.discount"
            params={{ discountValue: percentFormatter(DISCOUNT_AMOUNT) }}
            templates={[wrapTextWithTagFormatter(styles.highlightedDiscount)]}/>
    );

    const onDismiss = () =>
        deleteMessage({ messageId, userId });

    return (
        <Notice message={message}
            onDismiss={onDismiss}/>
    );
};

ReferralProgramInviteeDiscountNotice.propTypes = {
    messageId: number,
    userId: number
};

export default ReferralProgramInviteeDiscountNotice;
